<template>
    <form ref="form" v-on="formEvents">
        <div class="form-group">
            <label>Transaction Reference</label>
            <input type="text" v-model="form.reference" value="email" required
                   :class="['form-control', form.errors.get('reference') ? 'is-invalid' : '']" placeholder="Reference">
            <div v-text="form.errors.get('reference')" class="invalid-feedback"/>
        </div>
        <div class="form-group">
            <button type="button" v-bind="buttonValidity"
                    :class="{ 'btn-loading': form.loading, ...buttonValidity.class }"
                    @click="formVisibility ? submit($event) : (formVisibility = true)">
                Check Transaction
            </button>
        </div>
    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";

export default {
    name: "dashboard",
    components: {PhoneInput},
    mixins: [validity],
    data: function () {
        return {
            termsAccepted: true,
            meterLoading: false,
            fields: [
                'reference',
            ],
            meter: {},
            form: new Form({
                'reference': '',
            })
        };
    },

    watch: {},

    methods: {

        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(this.fields[i], this.form[this.fields[i]]);
            }
        },

        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                let value = localStorage.getItem(this.fields[i]);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },

        submit(event) {
            // Save to Local Storage

            if (this.valid) {
                event.preventDefault();
                this.saveToLocalStorage();
                this.form.submit('/transaction/check').then((response) => {

                    if (response.data.body.type === "App\\Zesa") {
                        this.$router.push(`/zesa/complete?id=${response.data.body.ref}`);
                    }

                    if (response.data.body.type === "App\\Airtime") {
                        this.$router.push(`/airtime/complete?id=${response.data.body.ref}`);
                    }

                    if (response.data.body.type === "App\\Bundle") {
                        this.$router.push(`/bundles/complete?id=${response.data.body.ref}`);
                    }

                    if (response.data.body.type === "App\\Telone") {
                        this.$router.push(`/telone/complete?id=${response.data.body.ref}`);
                    }

                    if (response.data.body.type === "App\\GiftPurchase") {
                        this.$router.push(`/gift-cards/complete?id=${response.data.body.ref}`);
                    }
                    if (response.data.body.type === "App\\TicketPurchase") {
                        this.$router.push(`/tickets/complete?id=${response.data.body.ref}`);
                    }

                    if (response.data.body.type === "App\\BillerPayment") {
                        this.$router.push(`/billers/complete?id=${response.data.body.ref}`);
                    }

                });
            }
        }
    },

    mounted() {
        // Check in Local Storage
        this.getFromLocalStorage();
    }
}
</script>

<style scoped></style>
